import * as commonUtils from '@dbp-toolkit/common/utils';
import {Notification} from './notification.js';

commonUtils.defineCustomElement('dbp-notification', Notification);
